import { DeliveryNoteLineItem } from "@finway-group/shared/lib/models/purchaseOrder/lineItem.interface"

import React from "react"
import { useTranslation } from "react-i18next"

export const LineItemCardReadOnly = ({ item, idx }: { item: DeliveryNoteLineItem<string>; idx: number }) => {
    const { t } = useTranslation()
    return (
        <div className="flex items-center gap-8 mb-12">
            <div className="w-40 font-bold bg-gray-100 rounded-full text-center p-2 flex items-center justify-center">{String(idx + 1)}</div>

            {item.materialCode ? (
                <div
                    className={`w-100 font-medium bg-gray-100 rounded-full overflow-x-auto`}
                    style={{
                        scrollbarWidth: "none",
                    }}
                >
                    <span className="px-8 py-4 whitespace-nowrap inline-block min-w-full text-center">{item.materialCode}</span>
                </div>
            ) : null}

            <div
                className={`flex-1 pt-4 px-8 font-medium flex break-words`}
                style={{
                    scrollbarWidth: "none",
                }}
            >
                <span className="max-w-400">{item.name}</span>
            </div>

            <div className="grid grid-cols-2 gap-5 justify-center">
                <span className="font-bold mb-1">{t("label:quantity")}</span>
                <span className="font-bold mb-1">{t("input:request.unit_of_measure")}</span>
                <span className="font-medium">{item.quantity}</span>
                <span className="font-medium">{item.unitOfMeasure}</span>
            </div>
        </div>
    )
}
